import type { Practitioner } from '@/mocks/practitioners';

// Ordre des forfaits pour le tri (Premium > ARS > AF > autres).
export const TIER_ORDER: Record<string, number> = { premium: 0, ars: 1, af: 2 };

// Palette d'avatars réutilisée quand la base ne fournit pas de couleur.
const COLOR_PALETTE = [
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-700',
];

// Construit les initiales à partir du nom (les titres Dr/Pr sont ignorés).
function computeInitials(name: string): string {
  const cleaned = name.replace(/^(Dr\.?|Pr\.?)\s+/i, '');
  const words = cleaned.split(/\s+/).filter((w) => /[A-Za-zÀ-ÿ]/.test(w));
  const first = words[0]?.[0] ?? '';
  const second = words[1]?.[0] ?? '';
  const initials = `${first}${second}`.toUpperCase();
  return initials || '?';
}

// Convertit une ligne brute de la table practitioners en objet Practitioner.
export function mapPractitionerRow(r: Record<string, unknown>): Practitioner {
  const id = String(r.id);
  const name = String(r.name ?? '');
  const paletteIndex = Math.abs(Number(id)) % COLOR_PALETTE.length;
  return {
    id,
    name,
    type: String(r.type ?? ''),
    category: String(r.category ?? ''),
    district: String(r.district ?? ''),
    address: String(r.address ?? ''),
    phone: typeof r.phone === 'string' && r.phone.length > 0 ? r.phone : undefined,
    price: Number(r.price ?? 0),
    conventionCode: String(r.convention_code ?? ''),
    nextSlot: String(r.next_slot ?? ''),
    isAvailableNow: Boolean(r.is_available_now),
    tags: Array.isArray(r.tags) ? (r.tags as string[]) : [],
    initials: r.initials ? String(r.initials) : computeInitials(name),
    color: r.color ? String(r.color) : COLOR_PALETTE[paletteIndex],
    whatsapp: typeof r.whatsapp === 'string' ? r.whatsapp : undefined,
    subscriptionTier: typeof r.subscription_tier === 'string' ? r.subscription_tier : undefined,
    rating: r.rating === null || r.rating === undefined ? undefined : Number(r.rating),
    reviews: r.reviews === null || r.reviews === undefined ? undefined : Number(r.reviews),
  };
}